import { useEffect, useState } from "react";
import moment from "moment";

import DayTechItem from "./DayTechItem";
import { can, getMinutesFromFormattedHours } from "src/Common/function";
import { TimesheetTableHeader, TimesheetTableFooter } from "./TimesheetTable";

const DayTimesheet = ({ timesheetData, currentDate, startDateString, timesheetUpdated, woStatus }) => {
  const [totalRegularMinutes, setTotalRegularMinutes] = useState(0);
  const [totalTravelMinutes, setTotalTravelMinutes] = useState(0);
  const [totalOverMinutes, setTotalOverMinutes] = useState(0);
  const [activeEditingTechId, setActiveEditingTechId] = useState(null);

  // Timesheet save always hits /update_timesheet_staff (wo:logTimesheet-gated),
  // so logging on a billed WO needs wo:logTimesheet AND the extra
  // wo:logBilledTimesheet — the latter unlocks editing once billed.
  const isFutureStartDate = moment(startDateString).isAfter(moment(), "day");
  const canEdit =
    !isFutureStartDate &&
    ((woStatus < 100 && can("wo:logTimesheet")) ||
      (woStatus === 100 && can("wo:logBilledTimesheet")));

  useEffect(() => {
    let totalRegularTimeMinutes = 0;
    let totalTravelTimeMinutes = 0;
    let totalOverTimeMinutes = 0;
    for (let tech of timesheetData) {
      if (tech?.timesheet) {
        for (let i = 0; i < tech.timesheet.length; i++) {
          const workDate = moment(startDateString).add(Number(tech.timesheet[i].dayDiff || 0), "days");
          const isSameDate = workDate.isSame(currentDate, "day");

          if (isSameDate) {
            totalRegularTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].regularTime);
            totalTravelTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].travelTime);
            totalOverTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].overTime);
          }
        }
      }
    }

    setTotalRegularMinutes(totalRegularTimeMinutes);
    setTotalTravelMinutes(totalTravelTimeMinutes);
    setTotalOverMinutes(totalOverTimeMinutes);
  }, [timesheetData, currentDate, startDateString]);

  useEffect(() => {
    setActiveEditingTechId(null);
  }, [currentDate, startDateString]);

  return (
    <div>
      <TimesheetTableHeader withAction={canEdit} />
      <div className="overflow-y-auto max-h-[360px]">
        {timesheetData.map((tech) => (
          <DayTechItem
            key={tech.id}
            tech={tech}
            currentDate={currentDate}
            startDateString={startDateString}
            timesheetUpdated={timesheetUpdated}
            activeEditingTechId={activeEditingTechId}
            setActiveEditingTechId={setActiveEditingTechId}
            canEdit={canEdit}
          />
        ))}
      </div>
      <TimesheetTableFooter
        label="Daily Total"
        regularMinutes={totalRegularMinutes}
        travelMinutes={totalTravelMinutes}
        overMinutes={totalOverMinutes}
        withAction={canEdit}
      />
    </div>
  );
};

export default DayTimesheet;
